import { useMutation, useQueryClient } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { toast } from "@/hooks/use-toast";

interface CompleteAssignmentParams {
  id: string;
  type: 'curriculum' | 'course';
}

export const useCompleteAssignment = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ id, type }: CompleteAssignmentParams) => {
      const table = type === 'curriculum' 
        ? 'curriculum_assignments' 
        : 'course_assignments';

      const { error } = await supabase
        .from(table)
        .update({ completed_at: new Date().toISOString() })
        .eq('id', id);

      if (error) throw error;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["user_assignments"] });
      toast({
        title: "Assignment completed!",
        description: "Great job on completing your learning assignment.",
      });
    },
    onError: (error) => {
      console.error('[useCompleteAssignment] Error:', error);
      toast({
        title: "Error",
        description: "Failed to mark assignment as complete. Please try again.",
        variant: "destructive",
      });
    },
  });
};
